import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: window.env.COGNITO_USER_POOL_ID,
      userPoolClientId: window.env.COGNITO_CLIENT_ID,
    },
  },
});
